const arr = [
                            '//www.moundwholesale.com/cdn/shop/t/14/assets/mound_confetti.png?v=151878000644150585761676064862',
                            '//www.moundwholesale.com/cdn/shop/t/14/assets/confetti-02.png?v=110296145413723262341675787284',
                            '//www.moundwholesale.com/cdn/shop/t/14/assets/confetti-03.png?v=179093115565908219051675787284',
                            '//www.moundwholesale.com/cdn/shop/t/14/assets/confetti-04.png?v=40221169980691373551675787284',
                            '//www.moundwholesale.com/cdn/shop/t/14/assets/confetti.png?v=181999004091246873131675787284'
                          ];
                          const submitButton = document.querySelector(".product-form__submit");
                          const animationContainer = document.querySelector(".product--small");

                          // gets desktop view width
                          const viewPort = document.documentElement.clientWidth;


                          submitButton.addEventListener("click", () => {
                            startAnimation()
                            let intervalValue = viewPort > 1400
                              ? 50
                              : 100;

                            // starts animation and stores the returned intervalID
                            let animation = setInterval(startAnimation, intervalValue);

                            // changes intervalID to null to stop the animation cycle
                            const endAnimation = () => {
                              clearInterval(animation);
                              animation = null;
                            };

                            // takes returned intervalID and triggers the end animation function
                            setTimeout(endAnimation, 2500);
                          });

                          const startAnimation = () => {
                            const animationWrapper = document.createElement("div");

                            // randomizes the css property "left " to span the whole screen
                            animationWrapper.style.left = Math.random() * 100 + "vw";
                            animationWrapper.style.animationDuration = 2 + "s";
                            animationWrapper.classList.add("animation_wrapper");

                            // randomizes the images that are being animated
                            animationWrapper.innerHTML = `<img src=${
                              arr[0]
                            } alt="Mivapeco vapes and Bongs and Flowers" />`;
                            animationContainer.insertAdjacentElement("afterbegin", animationWrapper);
                          };